const BulkArchive = ({ archiveActions, setArchiveActions }) => {
  const handleArchiveChange = (e) => {
    const {
      target: { name, value },
    } = e;

    setArchiveActions({
      ...archiveActions,
      [name]: value,
    });
  };

  return (
    <>
      <div className='form-group nice mt-4'>
        <label>Why Archiving:</label>
        <select
          name='reason_key'
          className='form-control'
          value={archiveActions.reason_key}
          onChange={handleArchiveChange}
        >
          <option value=''>Select...</option>
          <option value='not_interested'>Not interested</option>
          <option value='cant_help'>Can't help borrower</option>
        </select>
      </div>
      <div className='form-group nice mt-4'>
        <label>Give more details:</label>
        <textarea
          type='text'
          className='form-control'
          value={archiveActions.reason_description}
          onChange={handleArchiveChange}
          name='reason_description'
          placeholder='Give more details'
        ></textarea>
      </div>
    </>
  );
};

export default BulkArchive;
